var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3288 34.8905L25.4264 20.681L32.5312 27.7857M10.3288 34.8905H28.0907C31.0336 34.8905 33.4193 32.5048 33.4193 29.5619V20.681M10.3288 34.8905C7.38593 34.8905 5.00024 32.5048 5.00024 29.5619V11.8C5.00024 8.85712 7.38593 6.47144 10.3288 6.47144H21.874M31.6431 15.0476L31.6431 10.0238M31.6431 10.0238L31.6431 5M31.6431 10.0238L26.6193 10.0238M31.6431 10.0238L36.6669 10.0238M15.6574 14.4643C15.6574 15.9357 14.4645 17.1286 12.9931 17.1286C11.5217 17.1286 10.3288 15.9357 10.3288 14.4643C10.3288 12.9929 11.5217 11.8 12.9931 11.8C14.4645 11.8 15.6574 12.9929 15.6574 14.4643Z",
    stroke: "#616874",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingUpload);
export default __webpack_public_path__ + "static/media/billingUpload.63079a81605c9176ef12c7d18f672950.svg";
export { ForwardRef as ReactComponent };